<script>
import ItemStep from "./ItemStep.vue";
import Title from "./Title.vue";
import Button from "./Button.vue";
import ToggleSlider from "./ToggleSlider.vue";
import Filter from "./Filter.vue";
import ItemLink from "./ItemLink.vue";
import Selector from "./Selector.vue";

export default {
  name: 'Step',
  props: ['modelValue', 'currentStep', 'step', 'items', 'showFilterBlock', 'showLinkStep', 'showSelector'],
  components: {ItemLink, Filter, ToggleSlider, Title, ItemStep, Selector, Button},
  data(){
    return {
      value: {},
      egeFilter: false,
    }
  },
  methods: {
    getName() {
      return 'step-' + this.step
    },
    isChangeItem(){
      return this.currentStep !== this.step
    },
    isFiveItems(){
      return this.items.length === 5
    },
    isShowButtons(){
      return this.currentStep === this.step
    },
    isShowButtonBack(){
      return this.step > 1
    },
    isShowButtonNext(){
      return !this.isItemLink() && Object.keys(this.value).length > 0
    },
    isShowBlock(){
      return this.items.length > 0 && this.currentStep >= this.step
    },
    isDisabledItems(){
      return this.currentStep > this.step
    },
    isFilterShow(){
      return this.egeFilter
    },
    isItemLink(){
      return this.showLinkStep;
    },
    isSelector(){
      return this.showSelector;
    },
    isShowFilterToggle(){
      return this.showFilterBlock;
    },
    clickBack(event){
      this.$emit('update:currentStep', this.currentStep-1)
      this.$emit('change-step', event)
    },
    clickNext(event){
      this.$emit('update:modelValue', this.value)
      this.$emit('update:currentStep', this.currentStep+1)
      this.$emit('change-step', event)
    }
  }
}
</script>

<template>
  <div class="step" v-if="isShowBlock()">
    <div class="container">
      <div class="head-block">
        <Title :step="step">
          <slot></slot>
        </Title>
        <ToggleSlider
            v-if="isShowFilterToggle()"
            :disabled="this.isChangeItem()"
            name="ege-filter"
            v-model="egeFilter"
        >Калькулятор ЕГЭ</ToggleSlider>
      </div>
    </div>

    <div class="step-block">
      <div class="container">
        <Filter
            v-if="isFilterShow()"
            v-model="value"
            :show-buttons="isShowButtons()"
            @backButton="clickBack"
            @nextButton="clickNext"
        />
        <template v-else>
          <div class="items-link-block" v-if="isItemLink()">
            <ItemLink
                v-for="(item, index) in items"
                :key="'item-link-'+item.id"
                :data="items[index]"
            />
          </div>
          <div class="item-selector" v-else-if="isSelector()">
            <Selector
                v-model="value"
                :data="items"
                :name="getName()"
                :disabled="isDisabledItems()"
            />
          </div>
          <div :class="['items-block', {'item-block--selected-item': isChangeItem(), 'item-block--five-items': isFiveItems()}]" v-else>
              <ItemStep
                  v-for="(item, index) in items"
                  :key="'item-step-'+item.id"
                  v-model="value"
                  :data="items[index]"
                  :name="getName()"
                  :disabled="isDisabledItems()"
              />
          </div>

          <div :class="['buttons-block', {'only-next':!isShowButtonBack()}]" v-if="isShowButtons()">
            <Button class="blue" @click.prevent="clickBack" v-if="isShowButtonBack()">Назад к выбору</Button>
            <Button class="orange" @click.prevent="clickNext" v-if="isShowButtonNext()">Дальше</Button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "/src/style/variable";
  .step {
    margin-bottom: 20px;
    .head-block {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media #{$media-575}{
        align-items: flex-start;
        flex-direction: column;
        .toggle-slider {
          margin-top: 10px;
        }
      }
    }
    .step-block {
      padding: 20px 0;
      @media #{$media-820}{
        padding: 30px 0;
      }
      .items-block {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 40px;
        @media #{$media-1199}{
          grid-template-columns: repeat(2, 1fr);
        }
        @media #{$media-767}{
          grid-template-columns: repeat(1, 1fr);
        }
      }
      .items-link-block {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 40px;
        @media #{$media-1024}{
          grid-template-columns: repeat(2, 1fr);
        }
        @media #{$media-667}{
          grid-template-columns: repeat(1, 1fr);
        }
      }
      .buttons-block {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        &.only-next {
          justify-content: right;
        }
        @media #{$media-575}{
          flex-direction: column;
          gap: 15px;
        }
      }
    }
  }


</style>